import "./index.css";
import { Timer } from "./components/Timer";

export function App() {

  return (
    <div className="">
      <Timer/>
    </div>
  );
}

export default App;
